import React from 'react';
import styled from '@emotion/styled';

import { Theme } from 'ui_system/theme';
import { Text, iconStyle } from '../styles';

const Booking = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr 0.5fr;
  grid-template-rows: 90px;
  grid-template-areas: 'name guests arrow';
  border-bottom: 1px solid ${Theme.colors.lightLine};
  cursor: pointer;
`;

const BookingSection = styled('div')`
  grid-area: ${(props) => props.gridArea};
  height: 100%;
  padding: 15px;
  display: grid;
  align-items: center;
  ${iconStyle};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : 'unset'};
`;

const BookingRow = ({
  id,
  guestName,
  totalUnits,
  totalUnitsNoun,
  onSelect,
}) => {
  return (
    <a key={id} onMouseDown={() => onSelect(id)} style={{ display: 'block' }}>
      <Booking>
        <BookingSection gridArea="name" justifyContent="flex-start">
          <Text hover>{guestName}</Text>
        </BookingSection>
        <BookingSection gridArea="guests" justifyContent="center">
          <Text hover>
            <i className="af-people" />{' '}
            <Text hover bold marginRight={5} marginLeft={5}>
              {totalUnits}
            </Text>
            {totalUnitsNoun}
          </Text>
        </BookingSection>
        <BookingSection gridArea="arrow" justifyContent="flex-end">
          <i className="af-angle-right" />
        </BookingSection>
      </Booking>
    </a>
  );
};

export default BookingRow;
